<script>

    import { toast } from 'bulma-toast'
    import { userStore, notificationsStore, modalStore } from '../stores'
    
    import NotificationsService from '../$services/notifications.service.js'

    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'

    import Switch from '../$components/switch.svelte'
    import Date from '../$components/date.svelte'

    import Button from '../$components/button.svelte'
    import ButtonSave from '../$components/button.save.svelte'

    export let type = null

    let data = {view: false, important: false}
    let loading = false

    async function createNotification() {
        
        data.type = type

        if($userStore != null)
            data.userId = $userStore._id

        loading = true
        const resp = await NotificationsService.createNotification(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        toast({message: 'Notificación creada', type: 'is-success'})
        notificationsStore.append(resp.data)
        modalStore.set(null)
    }
    
</script>

<Form on:submit={ createNotification } { loading } >

    <div class="columns">
        <div class="column">
            <InputText bind:value={ data.subject } label="Tema" placeholder="Tema" />
        </div>
        <div class="column">
            <InputText bind:value={ data.message } label="Mensaje" placeholder="Mensaje" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <Switch bind:checked={data.important} label="¿Notificación urgente?" />
        </div>
    </div>

    <Date bind:value={data.expired} label="Fecha de expiración" />

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        <ButtonSave icon="plus" text="Crear" { loading } />
    </div>

</Form>